<section class="section breadcrumb-area overlay-dark d-flex align-items-center">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- Breamcrumb Content -->
                <div class="breadcrumb-content d-flex flex-column align-items-center text-center">
                    <h2 class="text-white text-uppercase mb-3">The Process</h2>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a class="text-uppercase text-white" href="index.html">Home</a></li>
                        <li class="breadcrumb-item"><a class="text-uppercase text-white" [routerLink]="'/about'">About</a></li>
                        <li class="breadcrumb-item text-white active">The Process</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section about-area ptb_100">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-lg-6">
                <!-- About Thumb -->
                <div class="about-thumb text-center">
                    <img src="assets/img/pexels-tara-winstead-8850709.jpg" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <!-- About Content -->
                <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                    <h2 class="mb-3" style="font-size: 2.1rem">First things first, what's the goal?</h2>
                    <p>While making a website isn't as difficult as it was back in the 2000s, we want to explain how our process differentiates itself from an ordinary website developer. First we sit down with you to determine what your goals are. Here are some of the frequent goals:</p>
                    <ul class="goal-list">
                        <li>First business to show up on a Google Search</li>
                        <li>More conversions from visitors</li>
                        <li>Getting more reoccuring customers</li>
                        <li>Developing a brand.</li>
                    </ul>
                    <br>
                    <p>Now that we have the goal in mind, we can setup the analytics that would be necessary to ensure we achieve your goal. Ideally we would want to get about three to four weeks of data to get our starting point for the data. Once we have this starting point, we can track our progress towards achieving this goal.</p>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section about-area ptb_100">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-lg-6">
                <!-- About Content -->
                <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                    <h2 class="mb-3" style="font-size: 2.5rem">The introductory Period</h2>
                    <p>Since not every marketing strategy works for every business, we have to now determine which strategy best fits your business. Thankfully we now have our analytics incorporated so we can try different strategies, interpret the data, and determine if this is what works for your business. </p>

                        <br>
                    <p>This is the time when we start gathering some general demographic information about the your target audience such as location, age, and gender. Once we have a decent understanding of who is looking at your product or services, we can begin using ad-campaigns, focusing on either Facebook Ads or Google Ads depending on the demographic that's being targeted</p>
                    <br>
                    <p>Before we get to that, we have to set the website up for email opt-in, usually we trade a discount or free shipping in exchange for a visitor's email address.<br>
                    To read more about the benefits of building your email list, click here to read the blog article on the subject</p>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <!-- About Thumb -->
                <div class="about-thumb text-center">
                    <img src="assets/img/pexels-lukas-590020.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
</section>


<section class="section about-area ptb_100">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-lg-6">
                <!-- About Thumb -->
                <div class="about-thumb text-center">
                    <img src="assets/img/pexels-canva-studio-3194519.jpg" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <!-- About Content -->
                <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                    <h2 class="mb-3" style="font-size: 2.5rem">Time to Market</h2>
                    <p>This is where we begin to see results, the main aspect of this section of the process is to pay for clicks on your website. This will increase your traffic, however we don't want to get relient on paid-traffic due to the cost associated with running ads. The goal here is to begin putting your business name and brand in the mind of your customers and to build an email list.</p>
                    <br>
                    <p>Once we have a potential customer clicking the ad, we'll want to offer them either free shipping or a discount in exchange for their email address. As their email address is vital in converting this visitor from a one-time customer to a reoccuring customer.</p>
                    <br>
                    <p>With their email address now added to our email list, we now have a way to reach customers who have shown interest in your product or service without having to pay Google or Facebook. Once you have a customer return, you have succesfully made a reoccuring customer.</p>
                </div>
            </div>
        </div>
    </div>
</section>
